import { useQuery } from "react-query";
import middlewareAPI from "../services/middleware";

const useAutocomplete = (
  prefix,
  mlses,
  statuses,
  fields,
  suggests,
  grouped
) => {
  const { isFetched, isFetching, data, error, refetch, isLoading } = useQuery(
    ["autocompleteMap", prefix, mlses, statuses, fields, suggests, grouped],
    async () => {
      if (!prefix?.label) {
        const { data } = await middlewareAPI.post("Autocomplete/suggest", {
          prefix,
          mlses,
          statuses,
          fields,
          suggests,
        });
        if (grouped) {
          const groupedData = data.reduce((acc, obj) => {
            if (!acc[obj.suggestType]) {
              acc[obj.suggestType] = [];
            }
            acc[obj.suggestType].push(obj);
            return acc;
          }, {});
          return groupedData;
        } else {
          return data;
        }
      }
    },
    {
      enabled: prefix !== "" && prefix !== null && prefix !== undefined,
      staleTime: 300000,
      cacheTime: 300000,
    }
  );
  return {
    isFetched,
    isFetching,
    isLoading,
    data,
    error,
    refetch,
  };
};

export default useAutocomplete;
